/**
 * CHEM2131 Experiment Configurations
 * Analytical Chemistry Laboratory
 */

import type { ExperimentConfig } from '@/types';

// Import individual experiment configurations
import experiment1Config from './experiment1.config';
import { experiment2Config, waterSampleData, testInfoData } from './experiment2.config';
import experiment3Config from './experiment3.config';
import experiment4Config from './experiment4.config';
import experiment5Config from './experiment5.config';
import experiment6Config from './experiment6.config';
import experiment7Config from './experiment7.config';
import experiment8Config from './experiment8.config';
import experiment9Config from './experiment9.config';
import experiment10Config from './experiment10.config';
import experiment11Config from './experiment11.config';
import type { WaterSampleData, TestInfo } from './experiment2.config';

// Re-export types for convenience
export type { WaterSampleData, TestInfo };

// Re-export experiment data helpers
export { waterSampleData, testInfoData };

// Export individual experiments
export {
  experiment1Config,
  experiment2Config,
  experiment3Config,
  experiment4Config,
  experiment5Config,
  experiment6Config,
  experiment7Config,
  experiment8Config,
  experiment9Config,
  experiment10Config,
  experiment11Config
};

// All CHEM2131 experiments indexed by ID
export const CHEM2131_EXPERIMENT_CONFIGS: Record<string, ExperimentConfig> = {
  exp1: experiment1Config,
  exp2: experiment2Config,
  exp3: experiment3Config,
  exp4: experiment4Config,
  exp5: experiment5Config,
  exp6: experiment6Config,
  exp7: experiment7Config,
  exp8: experiment8Config,
  exp9: experiment9Config,
  exp10: experiment10Config,
  exp11: experiment11Config,
};

// Get experiment config by ID
export function getExperimentConfig(experimentId: string): ExperimentConfig | undefined {
  return CHEM2131_EXPERIMENT_CONFIGS[experimentId];
}

// Get all available experiment configs (non-placeholder)
export function getAvailableExperiments(): ExperimentConfig[] {
  return Object.values(CHEM2131_EXPERIMENT_CONFIGS).filter(
    (config) => config.parts.length > 0
  );
}

// Check if an experiment is fully implemented
export function isExperimentImplemented(experimentId: string): boolean {
  const config = CHEM2131_EXPERIMENT_CONFIGS[experimentId];
  return config ? config.parts.length > 0 : false;
}

export default CHEM2131_EXPERIMENT_CONFIGS;
